var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrophyFlame(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 341,
    viewBox: "0 0 270 341",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_48_16887)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.6725 54.6229L192.981 24.9511L195.412 40.9187C212.4 37.4499 228.599 50.5854 231.595 70.2577C234.59 89.93 223.247 108.69 206.26 112.158L207.195 118.3L207.193 118.3C207.225 118.504 207.257 118.709 207.288 118.914C214.364 165.381 187.571 209.693 147.445 217.886C107.32 226.08 69.0554 195.053 61.98 148.586C61.9488 148.381 61.9182 148.176 61.8884 147.971L61.8864 147.971L60.9513 141.83C43.9637 145.299 27.7643 132.164 24.7689 112.491C21.7735 92.8189 33.1163 74.0593 50.1039 70.5905L47.6725 54.6229ZM52.7222 87.7862C43.9356 89.5805 38.0687 99.2837 39.618 109.459C41.1674 119.634 49.5463 126.428 58.3329 124.634L52.7222 87.7862ZM203.641 94.9625C212.428 93.1683 218.295 83.4651 216.746 73.2898C215.196 63.1144 206.817 56.3202 198.031 58.1144L203.641 94.9625Z",
    fill: "#FFC629"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.1286 49.4253L86.2203 135.404L86.2222 135.403C86.2521 135.608 86.2826 135.813 86.3138 136.018C93.3893 182.485 131.653 213.512 171.779 205.319C173.34 205 174.882 204.626 176.401 204.2C167.967 210.915 158.184 215.694 147.446 217.887C107.32 226.08 69.056 195.053 61.9806 148.586C61.9494 148.381 61.9189 148.176 61.889 147.971L61.887 147.972L47.6732 54.6232L73.1286 49.4253Z",
    fill: "#FFE166"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.492 116.154L167.401 30.1748L192.856 24.9768L207.07 118.325L207.068 118.326C207.1 118.53 207.132 118.735 207.163 118.939C213.757 162.244 190.937 203.676 155.322 215.747L158.58 237.142L141.61 240.608L138.336 219.104C130.693 219.574 123.201 218.657 116.07 216.52C117.624 216.318 119.182 216.059 120.743 215.74C160.869 207.547 187.661 163.235 180.586 116.768C180.555 116.563 180.523 116.358 180.49 116.154L180.492 116.154Z",
    fill: "#FFB018"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 148.307,
    height: 63.3638,
    transform: "matrix(0.979782 -0.20007 0.150531 0.988605 77.9727 253.603)",
    fill: "#6F200E"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 22.7332,
    height: 63.3638,
    transform: "matrix(0.979782 -0.20007 0.150531 0.988605 201.004 228.479)",
    fill: "#501508"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 121.244,
    height: 38.5153,
    transform: "matrix(0.979782 -0.20007 0.150531 0.988605 94.6914 262.853)",
    fill: "#FFC629"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 105.006,
    height: 27.3334,
    transform: "matrix(0.979782 -0.20007 0.150531 0.988605 100.742 266.683)",
    fill: "#FFE166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.618 154.62C128.158 155.526 120.493 149.45 119.597 141.115C119.151 136.948 120.396 133.071 122.92 129.994L130.31 119.136C131.442 117.493 133.908 117.229 135.362 118.595L144.888 127.638C147.888 130.123 150.048 133.638 150.497 137.801C151.275 146.146 145.074 153.714 136.615 154.623L136.618 154.62Z",
    fill: "#FFC629"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.717 92.1862L150.453 91.3729C148.93 90.3506 146.768 91.0553 146.131 92.7847C145.87 93.6404 146.4 101.875 146.55 103.281L146.638 104.099C146.764 105.271 145.819 106.321 144.632 106.212C143.687 106.192 142.893 105.334 142.793 104.396C141.166 90.3576 135.925 80.972 127.222 74.4433C121.969 70.5041 115.843 67.1371 114.424 70.3665C114.047 71.2346 114.932 72.9163 115.984 75.0561C118.152 79.9171 114.018 88.5335 107.787 97.3773C101.974 105.701 94.7197 115.955 96.2126 129.889C98.2228 148.625 117.617 163.719 136.926 161.647C156.241 159.575 171.985 140.708 169.972 121.972C168.705 110.142 161.867 99.03 151.717 92.1862ZM119.314 141.145C120.217 149.582 127.827 155.752 136.204 154.852C144.581 153.955 150.705 146.307 149.914 137.861C149.463 133.647 147.313 130.085 144.335 127.563L134.879 118.389C133.433 117.004 130.994 117.266 129.876 118.925L122.581 129.896C120.089 133.004 118.861 136.925 119.316 141.142L119.314 141.145Z",
    fill: "#DD850F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_48_16887",
    x: 0.289062,
    y: 0.951111,
    width: 256.531,
    height: 339.293,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_48_16887"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_48_16887",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophyFlame);
export default __webpack_public_path__ + "static/media/trophy_flame.f82cc955.svg";
export { ForwardRef as ReactComponent };